import _ from 'lodash'

const ua = navigator.userAgent
const android = /(Android ([0-9]))/gi.exec(ua)
const browser = {
    ios: /(iPhone|iPad|iPod|iOS)/i.test(ua),
    android: android ? parseInt(_.last(android), 10) : 0,
    isWx: !!ua.match(/MicroMessenger/i),
    isQQ: ua.match(/QQ/i) === 'qq',
    QQbrw: ua.indexOf('MQQBrowser') > -1, // QQ浏览器
}
export default browser
export const isIOS = () => browser.ios
export const isAndroid = () => !!browser.android
export const isWx = () => browser.isWx
export const isQQ = () =>  browser.isQQ
// export const isUseTxMap = (browser.android &&  browser.isQQ) || (browser.QQbrw && browser.android)
